module.exports = __webpack_public_path__ + "static/media/update.3bd528bd.svg";